import Fact from '@atlassian/bitkit-analytics';

type DiscoveryCardProps = {};

export class DiscoveryCardView extends Fact<DiscoveryCardProps> {
  name = 'bitbucket.connect.discovery_card.view';
}

export class DiscoveryCardMinimize extends Fact<DiscoveryCardProps> {
  name = 'bitbucket.connect.discovery_card.minimize';
}

export class DiscoveryCardExpand extends Fact<DiscoveryCardProps> {
  name = 'bitbucket.connect.discovery_card.expand';
}

export class DiscoveryCardClosed extends Fact<DiscoveryCardProps> {
  name = 'bitbucket.connect.discovery_card.closed';
}

export class DiscoveryCardBrowseClick extends Fact<DiscoveryCardProps> {
  name = 'bitbucket.connect.discovery_card.click';
}
